export class RepaymentDayDetails {
  public customerId: string;
  public applicationId: string;
  public day: number;
  constructor(customerId: string, applicationId: string, day: number) {
    this.customerId = customerId;
    this.applicationId = applicationId;
    this.day = day;
  }
}

export interface SanctionLetter {
  content: string;
  contentType: string;
  merchantId: string;
  version: string;
  lenderId: string;
}

export interface LenderDetails {
  referenceName: string;
  registeredName: string;
  grievancePolicyURL: string;
  logoURL: string;
}
